import { flowRight } from 'lodash';
import { BookingSectionView } from './BookingSection';
import withViewportDetection from '../../../config/viewport';
import { connect } from 'react-redux';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { withTheme } from 'styled-components';
import * as Actions from './actions';

export default flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withTheme,
    withViewportDetection,
)(BookingSectionView);

export { Actions };
